import FusePageCarded from '@fuse/core/FusePageCarded';
import withReducer from 'app/store/withReducer';
import React from 'react';
import reducer from '../store';
import TitleCompaniesHeader from './TitleCompaniesHeader';
import TitleCompaniesTable from './TitleCompaniesTable';

function TitleCompanies() {
  return (
    <FusePageCarded
      classes={{
        content: 'flex',
        contentCard: 'overflow-hidden',
        header: 'min-h-72 h-72 sm:h-136 sm:min-h-136 text-grey-800',
        topBg: 'light-header'
      }}
      header={<TitleCompaniesHeader />}
      content={<TitleCompaniesTable />}
      innerScroll
    />
  );
}

export default withReducer('dataDirectory', reducer)(TitleCompanies);
